import script from "./TableReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./TableReceipt.vue?vue&type=script&setup=true&lang=js"

import "./TableReceipt.vue?vue&type=style&index=0&id=3aadbbb0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aadbbb0"]])

export default __exports__